module.exports = __webpack_public_path__ + "img/bea4254.png";